import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTooltip,{attrs:{"top":"","transition":"fade-transition","reverse-transition":"fade-transition"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c(VAvatar,{attrs:{"size":_vm.size}},[(_vm.doHaveProfile)?_c('img',_vm._g(_vm._b({attrs:{"src":_vm.defaultPhotoProfile,"alt":"Profile Picture"}},'img',
          typeof _vm.tooltipWording !== 'undefined' &&
          _vm.tooltipWording !== '' &&
          _vm.tooltipWording !== null
            ? attrs
            : null
        ,false),
          typeof _vm.tooltipWording !== 'undefined' &&
          _vm.tooltipWording !== '' &&
          _vm.tooltipWording !== null
            ? on
            : null
        )):_c('img',_vm._g(_vm._b({attrs:{"src":_vm.picUrl,"alt":"Profile Picture"}},'img',
          typeof _vm.tooltipWording !== 'undefined' &&
          _vm.tooltipWording !== '' &&
          _vm.tooltipWording !== null
            ? attrs
            : null
        ,false),
          typeof _vm.tooltipWording !== 'undefined' &&
          _vm.tooltipWording !== '' &&
          _vm.tooltipWording !== null
            ? on
            : null
        ))])]}}])},[_vm._v(" "),_c('span',[_vm._v("\n    "+_vm._s(_vm.tooltipWording)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }